import React from 'react';
import { useTranslation } from 'react-i18next';
import { orderSourceType, SOURCE_TYPE } from '../../../../utils/enums';
import IconButton from '../../IconButton';
import { defaultPromiseResolve } from '../../../../utils/objects-util';
import "./index.scss";

export const NotesDraft = ({
    orderSource,
    addressNotes,
    comment,
    isExtraSize,
    isHighPriority
}) => {
    const { t } = useTranslation();

    const orderSources = orderSourceType();

    const noteText = `${addressNotes?.trim() ?? ''} ${comment?.trim() ?? ''}`;

    return (
        <div className="notesdraft">

            {orderSource !== undefined &&
                orderSource !== SOURCE_TYPE.logistic && (
                    <div className="notesdraft__source">
                        <span className="notesdraft__source-text">
                            {orderSources[orderSource]}
                        </span>
                    </div>
                )}

            {isExtraSize && (
                <IconButton isIcon={true} iconName="extraSize" onClick={defaultPromiseResolve} />
            )}
            {isHighPriority && (
                <IconButton isIcon={true} iconName="crown" onClick={defaultPromiseResolve} />
            )}

            <div className="notesdraft__content">
                <span className="notesdraft__label">
                    {t('draft.notes')}
                </span>

                <span className="notesdraft__text">
                    {noteText}
                </span>
            </div>

        </div>
    );
};
